import { Box } from "@mui/material";
import { useTranslation } from "../../../../localization/useTranslation";
import { DotLegalSelect } from "@dotlegal/dotlegal-ui-components";
import useTaskPoliciesHooks from "./TaskPolicies.hooks";

export interface ITaskPoliciesProps {
    addedPolicies: Array<string>;
    taskId: string;
    onPoliciesAdded: () => void;
}

function TaskPolicies(props: ITaskPoliciesProps) {
    const { translateString } = useTranslation();
    const { policies, policiesIsLoading, onPolicySelected } = useTaskPoliciesHooks(props);

    function getOptions() {
        return policies?.filter((x) => !props.addedPolicies.includes(x.id));
    }

    return (
        <Box sx={{ "& > *": { marginTop: 0 } }}>
            <DotLegalSelect
                options={getOptions()}
                selectedItem={null}
                isLoading={policiesIsLoading}
                label={translateString("policies")}
                noOptionsLabel={translateString("noOptions")}
                onChange={onPolicySelected}
                clearOnSelect
            />
        </Box>
    );
}

export default TaskPolicies;
